import messageCn from './cn/index'
import messageEn from './en/index'

const messages = {
    cn: {
        message: messageCn
    },
    en: {
        message: messageEn
    }
}

export default messages


// WEBPACK FOOTER //
// ./src/language/index.js